import { Box, Button, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_MODAL_BACKGROUND,
  LIGHT_MODAL_BACKGROUND,
  PRIMARY_BUTTON_BORDER,
  DARK_FIELDS_FLOATING_BUTTON_BACKGROUND,
  LIGHT_FIELDS_FLOATING_BUTTON_BACKGROUND,
  PRIMARY_BUTTON_BACKGROUND,
  DARK_CONTAINER_FIELDS_FLOATING,
  LIGHT_CONTAINER_FIELDS_FLOATING,
  LIGHT_CONTAINER_BORDER,
  PLAIN_TEXT,
  DARK_TEXT,
  PRIMARY_CONTAINER,
} = COLORS;

export const AddModalCont = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? DARK_MODAL_BACKGROUND : LIGHT_MODAL_BACKGROUND,
  padding: 20,
  minWidth: 485,
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.down('xs')]: {
    minWidth: 'calc(100vw - 90px)',
  },
}));

export const ModalButton = styled(Button)(({ theme }) => ({
  backgroundColor:
    theme.palette.type === 'dark' ? DARK_FIELDS_FLOATING_BUTTON_BACKGROUND : LIGHT_FIELDS_FLOATING_BUTTON_BACKGROUND,
  width: 258,
  height: 44,
  border: `solid 1px ${PRIMARY_BUTTON_BORDER}`,
  borderRadius: 5,
  padding: 1,
  margin: 7,
  borderImageSlice: 1,
  fontSize: 15,
  [theme.breakpoints.down(960)]: {
    width: '100%',
    fontSize: 12,
  },
}));

export const ModalHeader = styled(Box)(({ theme }) => ({
  fontSize: 24,
  fontWeight: 600,
  marginBottom: 35,
  [theme.breakpoints.down(960)]: {
    textAlign: 'center',
    fontSize: 22,
    marginTop: 10,
  },
}));

export const AddButton = styled(Button)(() => ({
  width: 258,
  height: 44,
  backgroundColor: PRIMARY_BUTTON_BACKGROUND,
}));

export const BinContent = styled(Box)(({ theme }) => ({
  background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING,
  flex: 1,
  width: '100%',
  marginBottom: 16,
  overflow: 'auto',
  marginTop: 45,
}));

export const UploadingCont = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 100,
}));

export const DropZone = styled(Box)(({ theme }) => ({
  minHeight: 300,
  minWidth: 500,
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: 20,
  borderWidth: 2,
  borderRadius: 8,
  borderColor: LIGHT_CONTAINER_BORDER,
  borderStyle: 'dashed',
  color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
  outline: 'none',
  transition: 'border .24s ease-in-out',
  cursor: 'pointer',
  justifyContent: 'center',
  [theme.breakpoints.down('xs')]: {
    minWidth: 'unset',
    minHeight: 44,
    backgroundColor: PRIMARY_CONTAINER,
    padding: '10px 30px',
    marginBottom: 20,
    color: 'white',
    border: 'solid 1px darkgray',
  },
}));
